document.querySelectorAll('.tabbed-content').forEach((scope) => {
    const panels = [];

    scope.querySelectorAll('[data-tab-target]').forEach((trigger) => {
        const target = trigger.dataset.tabTarget;
        const panel = scope.querySelector(`#${target}`) || scope.querySelector(`[data-tab-panel="${target}"]`);

        if (panel) {
            panel.classList.add('tabbed-content__panel');
            panel.classList.toggle('is-active', trigger.classList.contains('is-active'));
            panels.push(panel);
        }

        trigger.addEventListener('click', () => {
            if (!target) {
                return;
            }

            scope.querySelectorAll('[data-tab-target]').forEach((item) => {
                item.classList.toggle('is-active', item === trigger);
            });

            panels.forEach((panel) => {
                panel.classList.toggle('is-active', panel.id === target || panel.dataset.tabPanel === target);
            });
        });
    });
});
